import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Http } from '@angular/http';
import { JsonSchemaFormService } from 'angular4-json-schema-form-updated';
import * as moment from 'moment';
import { Subscription } from 'rxjs/Subscription';
import { CacheService } from '../../shared/services/cache.service';
import { DataShareService } from '../../shared/services/data.service';
import { DateConstants } from '../constants/date.constants';
import { AppCountryConfig } from '../interface/app-config';
import { AppConfigService } from '../services/app-config.service';
import { ConfigurationService } from '../services/configuration.service';


@Component({
    // tslint:disable-next-line:component-selector
    selector: 'custom-datepicker-widget',
    template: `
    <!-- [class]="options?.htmlClass || ''"-->
    <div [class.floatLabelContainer]="true">
      <label *ngIf="options?.title"
        [attr.for]="'control' + layoutNode?._id"
        [class]="options?.labelHtmlClass || ''"
        [style.display]="options?.notitle ? 'none' : ''"
        [innerHTML]="options?.title"></label>
      <input float-label
        [formControl]="formControl"
        [attr.aria-describedby]="'control' + layoutNode?._id + 'Status'"
        [attr.list]="'control' + layoutNode?._id + 'Autocomplete'"
        [attr.placeholder]="options?.placeholder"
        [attr.dateFormat]="options?.dateFormat"
        [attr.required]="options?.required"
        [class]="options?.fieldHtmlClass || ''"
        [disabled]="controlDisabled"
        [id]="'control' + layoutNode?._id"
        [name]="controlName"
        [readonly]="options?.readonly ? 'readonly' : null"
        [type]="layoutNode?.type"
        (input)="onDateInput($event)" 
        (dateTimeChange)="onDateInput($event)" 
        [owlDateTime]="dt3" [maxlength]="appConfig?.dateFormat?.length || 11" DateFormat>
        <owl-date-time [pickerType]="'calendar'" panelClass="'calendar-panel'" [startAt]="startDateTime" #dt3></owl-date-time>
        <span class="input-group-addon date-format" [owlDateTimeTrigger]="dt3">
            <span class="fa fa-calendar select-pointer" attr.aria-label="{{'common.Set current date'|translate|translateKey}}"
        tabindex="0"></span>
        </span>
        <!-- Email verification spinner block start -->
        <span *ngIf="layoutNode?.name==='email' && isShowLoader" tabindex="0" class="personal-info--email-info">
        <i class="fa fa-spinner"></i></span>
        <!-- Email verification spinner block end -->
    </div>
    <span *ngIf="customMessage && !isShowLoader" [class]="'error custom-error'">{{customMessage}}</span>`,
})
export class CustomDatePickerComponent implements OnInit {
    momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;
    formControl: AbstractControl;
    controlName: string;
    controlValue: string;
    controlDisabled = false;
    boundControl = false;
    customMessage: any;
    options: any;
    selectSubscription: Subscription;
    optionsGetUrl: any;
    validateUrl: any;
    storeId: any;
    isoCountryCode: string;
    enrollCountryCode: string;
    autoCompleteList: string[] = [];
    isShowLoader = false;
    @Input() layoutNode: any;
    @Input() layoutIndex: number[];
    @Input() dataIndex: number[];
    startDateTime: Date = new Date();
    appConfig: AppCountryConfig;
    constructor(
        private jsf: JsonSchemaFormService,
        private _http: Http,
        private chRef: ChangeDetectorRef,
        private _cacheService: CacheService,
        private _configurationService: ConfigurationService,
        private _dataService: DataShareService,
        private _appConfigService: AppConfigService
    ) { }

    ngOnInit() {
        this.enrollCountryCode = this._configurationService.getEnrollCountry().toUpperCase();
        //this.storeId = this._cacheService.get(CacheKey.StoreConfiguration).id;
        this.options = this.layoutNode.options || {};
        if (this.options) {
            this.controlValue = '';
            this.jsf.initializeControl(this);
        }
        this.setDefaultPickerDate();
        const joinFlowType = 'FBO';
        //Add Changes for perosnla info format
        this.appConfig = this._appConfigService.getSettings(this.enrollCountryCode, null);
        if(this.formControl && this.formControl.value){
            this.startDateTime = this.formControl.value;
        }
    }

    /**
     * @param  {any} event
     */
    updateValue(event: any) {
        this.jsf.updateValue(this, event.target.value);
    }

    /**
    * @param  {any} event
    */
    validateInputValue(event: any) {
        if (!this.options.readonly) {
        }
    }

    /**
    * set default Picker date
    * @memberof PersonalInfoComponent
    */
    setDefaultPickerDate(): void {
        this.startDateTime.setFullYear(new Date().getFullYear() - 18);
    }

    /**
    * @description update selected date into form values
    * @date 2018-01-03
    * @memberof AutoshipPromotionsProductsComponent
    */
    onDateInput($event: any): any {
        if ($event) {
            const characterCheck = /[a-zA-z]/;
            const dateInputPattern = /^[a-zA-Z0-9\-]*$/;
            let value =$event.target ? $event.target.value : $event.value;
            let dateFormatLength = 11;
            let dateFormat = this.appConfig.dateFormat;
            if (this.appConfig && this.appConfig.dateFormat && this.appConfig.dateFormat.length > 0) {
                dateFormatLength = this.appConfig.dateFormat.length;
                dateFormat = this.appConfig.dateFormat;
            }
            const dateValue: any = new Date(value);
            const isValidDate = dateValue + '' !== 'Invalid Date';
            if (value && value._i && (typeof value._i === 'object')) {
                value = this.momentConstructor(value._d).format(dateFormat);
            } else if (value && value._i && (typeof value._i === 'string')) {
                value = value._i;
            }
            if (value && value.length === 11 && (characterCheck.test(value[3])) && isValidDate) {
                let formattedDate = moment(value, dateFormat);
                this.startDateTime=formattedDate['_d'];
                if (this.formControl.parent) {
                    this.formControl.parent.controls[this.controlName].setValue(formattedDate);
                }
             }
           
        }
    }

    /**
     * @description update selected date into form values
     * @date 2018-01-03
     * @memberof AutoshipPromotionsProductsComponent
     */
    onDateChange($event: any): any {
        const today = new Date();
        if ($event !== undefined && $event !== null &&
            $event.value !== null && $event.value !== undefined) {
            const selectedDate = new Date($event.value._d.getFullYear(), $event.value._d.getMonth(),
                $event.value._d.getDate(), today.getHours(), today.getMinutes(), today.getSeconds(), 0);
            this.jsf.updateValue(this, selectedDate);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/widgets/custom-datepicker.widget.ts